export const LOCAL_STORAGE_PREFIX = 'qii_ai_';
